import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 06F6526C-6D2A-45F5-A5DF-46860DE27EAC
 * name checkbox-blank-off-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-blank-off-outline.svg
 * tags
 * - Form 
 */
export const CheckboxBlankOffOutlineIcon = createSvgIcon(<><path d="M22.11 21.46L2.39 1.73L1.11 3L3 4.9V19C3 20.11 3.9 21 5 21H19.1L20.84 22.73L22.11 21.46M5 19V6.89L17.11 19H5M8.2 5L6.2 3H19C20.1 3 21 3.89 21 5V17.8L19 15.8V5H8.2Z" /></>, 'CheckboxBlankOffOutlineIcon');
export default CheckboxBlankOffOutlineIcon